// All or portions of this file Copyright © 2019 Amazon Web Services, Inc. or its affiliates or licensors.
// All rights reserved. For full license terms and conditions, please see the LICENSE file at the root of
// this distribution (the "License") or go to https://content.sumerian.amazonaws.com/engine/latest/license.txt.
// All use of the software is governed by the License. All materials are made available on an "AS IS" BASIS, WITHOUT
// WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. Do not remove or modify any license notices.
import Component from '../../../entities/components/Component';


/**
 * The component to manage the particle uniforms and render list.
 * NOTE: This particle component does not have corresponding UI in frontend.
 */
class ParticleRendererComponent extends Component {
  constructor(material) {
    super();
    /**
     * type of component
     * @type {string}
     */
    this.type = 'ParticleRendererComponent';

    /**
     * Render list to be processed in partitioner.
     * @type {Array<ParticleData>}
     */
    this.renderList = [];

    /**
     * the material to be set on each particle.
     * @type {Material}
     */
    this.material = material;
  }

  /**
   * Process the particle array and generate the corresponding uniforms and renderList
   * @param {Array<ParticleData>} particles the array of particles
   */
  process(particles) {
    if (this.entity) {
      this.renderList = [];
      const transform = this.entity.transformComponent.sync().worldTransform;
      let activeParticleCount = 0;

      //If the instance uniform array are not defined, the shader has not been compiled or compiled unsuccessfully
      //Skip assigning uniforms in these case.
      if (this.material.uniforms.timeInfoInstances === undefined || this.material.uniforms.startPosInstances === undefined || this.material.uniforms.startDirInstances === undefined) {
        console.warn('[Sumerian] The shader for particle data is not compiled. Skip setting the uniforms');
        return;
      }

      for (let particle of particles) {
        if (particle.active) {
          const pos = particle.startPosition;
          const dir = particle.startDirection;
          this.material.uniforms.timeInfoInstances[activeParticleCount] = [
            particle.lifeTime,
            particle.active,
            particle.emitRandom,
            particle.emitTime
          ];

          this.material.uniforms.startPosInstances[activeParticleCount] = [pos.x, pos.y, pos.z, 1.0];
          this.material.uniforms.startDirInstances[activeParticleCount] = [dir.x, dir.y, dir.z, particle.loopAfter];
          const renderInfo = {
            material: this.material,
            transform: transform
          };
          this.renderList.push(renderInfo);
          activeParticleCount++;
        }
      }
    }
  }

  /**
   * Attach an entity to the component
   * @param {Entity} entity
   */
  attached(entity) {
    this.entity = entity;
  }

  /**
   * Detach an entity from the component
   * @param {Entity} entity
   */
  detached(entity) {
    this.entity = null;
    this.renderList = [];
  }
}
export default ParticleRendererComponent;
